import React, { useState, useEffect, useContext } from 'react';
import { AddToCartContext } from './AddToCartContext';

import './CartButton.css';

const cartIcon = 'https://cdn.obsess-vr.com/umg/cart-icon-red.png';

// TODO: PASS IN CART PAGE URL, CART TEXT STYLE, AND CART TEXT AS PROPS
const CartButton = ({ onClick }) => {
    const { itemCount } = useContext(AddToCartContext);
    return (
        <div className='cart-button-container flex-center hoverable' onClick={onClick}>
            <div className='cart-icon-container flex-center'>
                <div className="cart-count-section">
                        {itemCount > 0 && <span className='item-count'>{itemCount}</span>}
                </div>
                <img className='cart-icon' src={cartIcon} />
            </div>
            <span className='cart-button-text'>CART</span>
        </div>
    )
}

export default CartButton;